import { Heading, Box, List, ListItem, ListIcon, Button, Text, Grid } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CheckMarkIcon from '@/assets/icons/ic-check-mark.svg';
import LinkOuterIcon from '@/assets/icons/ic-link-outer.svg';

import { LibrariansScienceOrganizations } from '@/components/ui/features/librarians/LibrariansScience/components/LibrariansScienceOrganizations/LibrariansScienceOrganizations';

export const LibrariansScience: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid
      py={{ base: 10, lg: 24 }}
      templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
      columnGap={{ base: 0, lg: 14 }}
      gridTemplateAreas={{
        base: `"title" "list" "button" "organizations"`,
        lg: `"title list" "button organizations"`,
      }}
    >
      <Heading
        fontSize={{ base: '32px', lg: '48px' }}
        lineHeight={{ base: 10, lg: '60px' }}
        pb={{ base: 10, lg: 0 }}
        gridArea="title"
      >
        {t('librarians.science.title')}
      </Heading>
      <Box gridArea="button" mb={{ base: 20, lg: 0 }}>
        <NextLink href="/library" passHref legacyBehavior>
          <Button rightIcon={<LinkOuterIcon />} colorScheme="black">
            {t('librarians.science.button')}
          </Button>
        </NextLink>
      </Box>

      <List gridArea="list" pt={4} pb={{ base: 16, lg: 10 }} spacing={6}>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.science.specifications.0')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.science.specifications.1')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.science.specifications.2')}</Text>
        </ListItem>
      </List>

      <Box gridArea="organizations">
        <LibrariansScienceOrganizations />
      </Box>
    </Grid>
  );
};
